
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dIecw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GLOBAL_SCOPE_ROUTES", () => $632ff6997ab39649$export$f47036775f4cb978);
$parcel$export(module.exports, "default", () => $632ff6997ab39649$export$2e2bcd8739ae039);

var $jcw0u = parcelRequire("jcw0u");

var $fu3P4 = parcelRequire("fu3P4");
const $632ff6997ab39649$export$f47036775f4cb978 = [
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect'
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$632ff6997ab39649$export$2e2bcd8739ae039 = async (routerContext, customContext)=>{
    // If we're rendering Global Scope in SSR then we can assume the user is enrolled, as the monolith has decided to
    // send the request to Jira Frontend
    const isGlobalScopeRoute = $632ff6997ab39649$export$f47036775f4cb978.includes(routerContext.route.name);
    if (false && isGlobalScopeRoute) return true;
    try {
        return await (0, $fu3P4.default)(customContext.tenantContext.cloudId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $jcw0u.default)({
            meta: {
                id: 'jiraNinGlobalScopeEnrolmentEnabledResource',
                packageName: 'jiraRouterResourcesIsNinGlobalScopeEnrolmentEnabled',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return false;
    }
};

});
parcelRegister("fu3P4", function(module, exports) {

$parcel$export(module.exports, "default", () => $667869f7351d8a5e$export$2e2bcd8739ae039);

var $eusud = parcelRequire("eusud");
const $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY = `
    query SelectedGlobalScopeIssueNavigatorQuery($cloudId: ID!) {
        myPreferences(keys: [
            "jira.user.nin.global.scope.enrolment"
        ]),
        jira {
            applicationPropertiesByKey(cloudId: $cloudId, keys: ["jira.admin.nin.global.scope.enrolment"]) {
                value
            }
        }
    }
`;
const $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer = async (cloudId)=>{
    const apiResult = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $667869f7351d8a5e$var$SELECTED_GLOBAL_SCOPE_ISSUE_NAVIGATOR_QUERY,
            variables: {
                cloudId: cloudId
            }
        })
    });
    const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.global.scope.enrolment'];
    if (userPreferenceValue !== 'nin' && userPreferenceValue !== 'gin' && userPreferenceValue !== null) throw new RangeError('Unexpected user preference value');
    const applicationPropertyValue = apiResult.data.jira.applicationPropertiesByKey[0].value;
    if (applicationPropertyValue !== 'true' && applicationPropertyValue !== 'false') throw new RangeError('Unexpected application property value');
    return userPreferenceValue !== 'gin' && applicationPropertyValue === 'true';
};
var $667869f7351d8a5e$export$2e2bcd8739ae039 = $667869f7351d8a5e$var$fetchIsGlobalScopeEnrolmentEnabledFromServer;

});



//# sourceMappingURL=async-resource-issue-navigator-global-scope-enrolment.b7bdd581.js.map
